export default __webpack_public_path__ + "static/media/SideBar1.6fbd3945.jpg";